import React, {useEffect} from 'react';
import {Icon, PriorityIcon, TriggerWrapperV2} from '@priority-software/priority-style-react';
import {SearchInput} from '../../FormHeader/components/Search/SearchInput';

export const InputTrigger = props => {
    const {focusedIndex, isMulti, triggerRef, isOpen} = props;
    const {
        onFocus,
        onBlur,
        autoFocus = true,
        autoSelect = true,
        ...restInputProps
    } = props.inputProps || {};

    useEffect(() => {
        if (isMulti && isOpen) {
            if (focusedIndex === -1) {
                triggerRef?.current.focus();
            } else {
                triggerRef?.current.blur();
            }
        }
    }, [focusedIndex, isMulti, isOpen, triggerRef]);

    const handleArrowClick = () => {
        const {isOpen, onClose, onOpen} = props;
        isOpen ? onClose() : onOpen();
    };

    const handleInputFocus = () => {
        props.onTriggerFocus();
        onFocus?.();
    };

    const handleInputBlur = () => {
        props.onTriggerBlur();
        onBlur?.();
    };

    return (
        <TriggerWrapperV2
            isOpen={props.isOpen}
            style={props.triggerButton && {display: 'flex', maxWidth: '100%'}}
        >
            <SearchInput
                {...restInputProps}
                value={props.searchQuery}
                onChange={props.onSearchChange}
                autoFocus={autoFocus}
                autoSelect={autoSelect}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                inputRef={props.triggerRef}
                direction={props.direction}
                displayClear={props.isOpen}
            >
                <Icon
                    icon={props.isOpen ? PriorityIcon.arrowDropUp : PriorityIcon.arrowDropDown}
                    onClick={handleArrowClick}
                    skin="standart"
                />
            </SearchInput>
            {props.triggerButton}
        </TriggerWrapperV2>
    );
};
